import { interfaces } from 'inversify';

import { Resettable } from './resettable.model';

export const RESETTABLE_SERVICE = <interfaces.ServiceIdentifier<Resettable>>Symbol.for('ResettableService');
